import styled from 'styled-components';

import { AlertSeverity } from '@sternum/web/features/alerts/models';

import { getSeverityColor } from '../../utils';

export const SeverityIndicatorStyled = styled.div<{ severity?: AlertSeverity; height: number }>`
  width: 2px;
  min-width: 2px;
  height: ${({ height }) => height}px;
  border-radius: 4px;
  background: ${(props) => {
    return getSeverityColor(props.severity!);
  }};
`;
